import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ISimMapping } from "@app/interfaces/ISimMapping";
import { Observable } from "rxjs";
import { ICombinedSimMappingQueryOptions } from "../_routes/hardware/_models/ICombinedSimMappingQueryOptions";

@Injectable({
    providedIn: 'root'
})
export class SimMappingService {
    constructor(
        private readonly http: HttpClient) { }

    endSimMapping(simMapping: ISimMapping): Observable<ISimMapping> {
        return this.http.post<ISimMapping>(`/api/sims/mappings/end`, simMapping);
    }

    addSimMapping(simMapping: ISimMapping): Observable<ISimMapping> {
        return this.http.post<ISimMapping>(`/api/sims/mappings`, simMapping);
    }

    getSimMappings(options: ICombinedSimMappingQueryOptions): Observable<ISimMapping[]> {
        return this.http.get<ISimMapping[]>(`/api/sims/mappings`, { params: options as HttpParams });
    }
}
